/* eslint-disable camelcase */
class RoomConfigCollection {
    color: string;

    designColor: string;

    design_type: string;

    wallType: number;

    text: string;

    text_visible: boolean = true;

    text_area_visible: boolean = true;

    area_use_jyou: boolean = true;

    default_width: number;

    default_depth: number;
}
export default RoomConfigCollection;
